export const AUTH_TOKEN_KEY = 'auth-token'

export enum LocalStorage {
  USER_ID = 'userId',
  USER_CHILD_ID = 'userChildId',
  USER_NAME = 'userName',
  EMAIL = 'email',
  IN_ONBOARDING = 'inOnboarding',
  ACTIVATED_PRODUCTS = 'activatedProducts',
  PLATFORM = 'platform',
  COMPANY_NAME = 'companyName',
  BUSINESS_ID = 'businessId',
  TAX_ID = 'taxId',
  LOCALE = 'locale',
  FFW_NAME = 'ffw_name',
  CUSTOMER_TYPE = 'customer_type',
  MAIN_MENU_IS_COLLAPSED = 'mainMenuIsCollapsed',
}

export const LocalStorageAuthKey = [
  LocalStorage.USER_ID,
  LocalStorage.USER_CHILD_ID,
  LocalStorage.USER_NAME,
  LocalStorage.EMAIL,
  LocalStorage.IN_ONBOARDING,
  LocalStorage.ACTIVATED_PRODUCTS,
  LocalStorage.PLATFORM,
  LocalStorage.COMPANY_NAME,
  LocalStorage.BUSINESS_ID,
  LocalStorage.TAX_ID,
  LocalStorage.FFW_NAME,
  LocalStorage.CUSTOMER_TYPE,
  'auth',
  'userSegment',
  'inProposalAccepted',
  'INPL__invoices',
]

export enum UserType {
  CUSTOMER = 'CUSTOMER',
  FFW = 'FFW',
  FFW_CUSTOMER = 'FFW_CUSTOMER',
}
